export * from './inventory.component';
export * from '../services/inventory.service';
export * from './inventory.routes';
export * from './article-detail/article-detail.component';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/inventory/index.ts